import React, { Component } from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';

class TypeToConfirm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmed: false,
    };
  }

  handleChange = event => {
    const { value } = event.target;
    const { confirmationText, onConfirmationChange } = this.props;

    this.setState({ confirmed: value === confirmationText });
    onConfirmationChange(value === confirmationText);
  };

  render() {
    const { className, fullWidth, placeholder, white } = this.props;
    const hasPlaceholder = !!placeholder;
    const hasClassName = !!className;

    const inputClassName = classNames('NewInput mt-8 mb-16', {
      'NewInput--fw': fullWidth,
      'NewInput--white': white,
      [className]: hasClassName,
    });

    return (
      <>
        <input
          onChange={e => this.handleChange(e)}
          className={inputClassName}
          name="confirmation"
          placeholder={hasPlaceholder ? placeholder : ''}
        />
        {this.state.confirmed ? (
          <Icon name="correct" className="ml-4 c-brand-gray" />
        ) : (
          <Icon name="error" className="ml-4 c-brand-gray" />
        )}
      </>
    );
  }
}

export default TypeToConfirm;
